/**
Service for fetching a list of hydro models.
*/

import { GeoWebServiceClient } from './GeoWebServiceClient'

/**
 * Object type describing the returned hydro models.
 */
export interface HydroModelObject {
  Id: number
  Name: string
  LongName: string
  Color: string
  EndDate: string
  MessuringPeriode: string
  WMSLayerName1: string
  WMSLayerName2: string
  WMSShapeUrl1: string
  WMSShapeUrl2: string
  areaInfo: {
    Description: string
    Id: number
    ModelBbox: {
      MinX: number
      MinY: number
      MaxX: number
      MaxY: number
      Srid: number
    }
  }
}

/**
 * Web service for fetching a list of hydro models.
 */
export class HydroModel extends GeoWebServiceClient {
  static get URL (): string { return 'https://data.geo.dk/api/v3/hydromodel' }

  /**
   * Constructor.
   * @param token The Geo auth token.
   */
  constructor (token: string) {
    const defaultParams = {
      srid: '25832',
      geoareaid: '1'
    }
    super(HydroModel.URL, token, defaultParams)
  }

  /**
   * Validates that required params are given.
   */
  private validateParams (): void {
  }

  /**
   * Calls the web service.
   * @returns A promise bearing a list of hydro model object.
   */
  async fetchHydroModels (): Promise<HydroModelObject[]> {
    this.validateParams()
    const response: Response = await fetch(this.url(), { headers: { Authorization: `Bearer ${this.token}` } })
    if (!response.ok) {
      throw new Error('Got invalid HTTP response.')
    }
    return await response.json()
  }
}
